module.exports = __webpack_public_path__ + "static/media/cleiton-paulino.d30019dc.jpeg";